import styled from 'styled-components'

export const CopyToClipboardComponent = styled.div`
  position: relative;

  .input-to-copy {
    opacity: 0;
    max-width: 300px;
    height: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
  }

  .btn-copy-to-clipboard {
    display: inline-flex;
    align-self: flex-start;
    cursor: ${ (props) => (props.enabled ? 'pointer' : 'inherit') };

    .btn {
      line-height: 22px;
    }

    .label {
      text-decoration: underline;
    }
  }
`
